import React from "react";
import { Link } from "react-router-dom";
import img1 from "../assets/images/real.jpg";

function Service() {
  return (
    <>
      {/* About Start */}
      <section className="services-section">
        <div className="container-xxl">
          <div className="container">
            <div className="services-header wow fadeIn" data-wow-delay="0.1s">
              <span className="services-eyebrow">What we do</span>
              <h2 className="services-title">Services built around your goals</h2>
              <p className="services-subtitle">
                From discovery to closing, we bring strategy, transparency, and
                dedicated advisors to every real estate decision.
              </p>
            </div>

            <div className="row g-5 align-items-center">
              <div className="col-lg-6 wow fadeIn" data-wow-delay="0.2s">
                <div className="services-media">
                  <img className="img-fluid" src={img1} alt="Property tour" />
                  <div className="services-badges">
                    <div className="services-badge">
                      <span>Fast closings</span>
                      <strong>14 days avg.</strong>
                    </div>
                    <div className="services-badge">
                      <span>Coverage</span>
                      <strong>Abuja + Lagos</strong>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 wow fadeIn" data-wow-delay="0.4s">
                <div className="services-content">
                  <h3>What you get with Royal Mines</h3>
                  <p>
                    Welcome to our comprehensive real estate services. From
                    property sales and mortgage assistance to construction
                    projects, we provide tailored solutions for every need.
                  </p>
                  <div className="services-grid">
                    <div className="service-item">
                      <span className="service-check">
                        <i className="fa fa-check"></i>
                      </span>
                      <div>
                        <h4>Mortgage planning</h4>
                        <p>Custom financing paths aligned with your goals.</p>
                      </div>
                    </div>
                    <div className="service-item">
                      <span className="service-check">
                        <i className="fa fa-check"></i>
                      </span>
                      <div>
                        <h4>Construction support</h4>
                        <p>Guidance through design, build, and handover.</p>
                      </div>
                    </div>
                    <div className="service-item">
                      <span className="service-check">
                        <i className="fa fa-check"></i>
                      </span>
                      <div>
                        <h4>Property sourcing</h4>
                        <p>Curated listings with verified ownership.</p>
                      </div>
                    </div>
                    <div className="service-item">
                      <span className="service-check">
                        <i className="fa fa-check"></i>
                      </span>
                      <div>
                        <h4>Investor advisory</h4>
                        <p>Market insights for stronger ROI decisions.</p>
                      </div>
                    </div>
                    <div className="service-item">
                      <span className="service-check">
                        <i className="fa fa-check"></i>
                      </span>
                      <div>
                        <h4>Legal coordination</h4>
                        <p>Transparent documentation and due diligence.</p>
                      </div>
                    </div>
                    <div className="service-item">
                      <span className="service-check">
                        <i className="fa fa-check"></i>
                      </span>
                      <div>
                        <h4>Move-in support</h4>
                        <p>Seamless handover with post-sale assistance.</p>
                      </div>
                    </div>
                  </div>
                  <div className="services-actions">
                    <Link className="btn hero-btn hero-btn-primary" to="/contact">
                      Speak with a specialist
                    </Link>
                    <Link className="btn hero-btn hero-btn-ghost" to="/properties">
                      View listings
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About End */}
    </>
  );
}

export default Service;
